<div class="row">
  <div class="col-md-12 mb-2">
    <h2>Application details</h2>
  </div>
</div>
<div class="row">
  <div class="col-md-4">
    <div class="form-group">
      <label>Applicant number</label>
      <div
        type="text"
        class="form-control readonly"
        [innerHTML]="applicantNumber || '-'"
      ></div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="form-group">
      <label>Applicant name</label>
      <div
        type="text"
        name="reg"
        class="form-control readonly"
        [innerHTML]="fullName"
      ></div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="form-group">
      <label>Registration route</label>
      <div
        type="text"
        name="reg"
        class="form-control readonly"
        [innerHTML]="userRoute || '-'"
      ></div>
    </div>
  </div>
</div>

<div class="col-md-12 accordion-parent">
  <cdk-accordion class="example-accordion">
    @for (form of forms; track form; let index = $index) {
      <cdk-accordion-item
        #accordionItem="cdkAccordionItem"
        class="example-accordion-item"
        role="button"
        tabindex="0"
        [attr.id]="'accordion-header-' + index"
        [attr.aria-expanded]="accordionItem.expanded"
        [attr.aria-controls]="'accordion-body-' + index">
        <div class="example-accordion-item-header" (click)="onFormIdSelect(form.id);accordionItem.toggle()">
          <h5>{{ form.regBodyName }}  -  <span>{{getApplicationStatus(form.status)}}</span></h5>
          <span class="example-accordion-item-description">
            @if (!accordionItem.expanded) {
              <i class="fa fa-caret-down"></i>
            }
            @if (accordionItem.expanded) {
              <i class="fa fa-caret-up"></i>
            }
          </span>
        </div>
        <div
          class="example-accordion-item-body"
          role="region"
          [style.display]="accordionItem.expanded ? '' : 'none'"
          [attr.id]="'accordion-body-' + index"
          [attr.aria-labelledby]="'accordion-header-' + index">
          <!-- application starts here -->
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Date Submitted</label>
                <div
                  type="text"
                  class="form-control readonly"
                [innerHTML]="
                  selectedApplication?.form?.dateApplicationSubmitted
                    ? (selectedApplication?.form?.dateApplicationSubmitted | utcDate)
                    : '-'
                "
                ></div>
              </div>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label
                      >Is this the name you want to be registered with and displayed on the certificate issued?</label
                      >
                      <div
                        type="text"
                        class="form-control readonly"
                        [innerHTML]="confirmNameChange"
                      ></div>
                    </div>
                  </div>
                </div>
                @if (confirmNameChange === 'No') {
                  <div>
                    <div class="row">
                      <div class="col-md-4">
                        <div class="form-group">
                          <label>Title</label>
                          <div
                            type="text"
                            name="reg"
                            class="form-control readonly"
                            [innerHTML]="professionalStandingDetail?.title?.name|| '-'"
                          ></div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">
                        <div class="form-group">
                          <label>First Name</label>
                          <div
                            type="text"
                            name="reg"
                            class="form-control readonly"
                            [innerHTML]="professionalStandingDetail?.forenames || '-'"
                          ></div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label>Middle Name</label>
                          <div
                            type="text"
                            name="reg"
                            class="form-control readonly"
                            [innerHTML]="professionalStandingDetail?.middleName || '-'"
                          ></div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label>Last Name</label>
                          <div
                            type="text"
                            name="reg"
                            class="form-control readonly"
                            [innerHTML]="professionalStandingDetail?.surname || '-'"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
              <br/>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-12 mb-2">
                    <h5>Overseas Regulator Details</h5>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Regulatory body</label>
                      <div
                        type="text"
                        class="form-control readonly"
                        [innerHTML]="regulatoryBody?.name || '-'"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-12 mb-2">
                    <h5 class="subHeading">Address</h5>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Line 1</label>
                      <div
                        type="text"
                        class="form-control readonly"
                        [innerHTML]="regulatoryBody?.addressLine1 || '-'"
                      ></div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Line 2</label>
                      <div
                        type="text"
                        name="reg"
                        class="form-control readonly"
                        [innerHTML]="regulatoryBody?.addressLine2 || '-'"
                      ></div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Line 3</label>
                      <div
                        type="text"
                        class="form-control readonly"
                        [innerHTML]="regulatoryBody?.addressLine3 || '-'"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>County</label>
                      <div
                        type="text"
                        class="form-control readonly"
                        [innerHTML]="regulatoryBody?.countyState || '-'"
                      ></div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Postcode</label>
                      <div
                        type="text"
                        name="reg"
                        class="form-control readonly"
                        [innerHTML]="regulatoryBody?.postCode || '-'"
                      ></div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Country</label>
                      <div
                        type="text"
                        class="form-control readonly"
                        [innerHTML]="regulatoryBody?.country || '-'"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Email</label>
                      <div
                        type="text"
                        class="form-control readonly"
                        [innerHTML]="regulatoryBody?.standardEmail || '-'"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-12 mb-2">
                    <h5 class="subHeading">Additional regulator contact details</h5>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Contact name</label>
                      <div
                        type="text"
                        class="form-control readonly"
                        [innerHTML]="professionalStandingDetail?.contactName || '-'"
                      ></div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Telephone number</label>
                      <div
                        type="text"
                        name="reg"
                        class="form-control readonly"
                        [innerHTML]="professionalStandingDetail?.telephone || '-'"
                      ></div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Email address</label>
                      <div
                        type="text"
                        class="form-control readonly"
                        [innerHTML]="professionalStandingDetail?.emailAddress || '-'"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-12 mb-2">
                    <h5>Initial Pharmacy Qualification Details</h5>
                  </div>
                </div>
              </div>
              @if (isUserPharmacist && routeValue === 'UK') {
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-12 mb-2">
                      <h5>Education</h5>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="row">
                    <!-- <div class="col-md-12"> -->
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>Degree</label>
                        <div
                          type="text"
                          name="reg"
                          class="form-control readonly"
                          [innerHTML]="UKdetails?.courseName"
                        ></div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>Year awarded</label>
                        <div
                          type="text"
                          class="form-control readonly"
                          [innerHTML]="UKdetails?.yearQualified"
                        ></div>
                      </div>
                    </div>
                  <!-- </div> -->
                </div>
              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-12 mb-2">
                    <h5>Pre-registration training/Foundation training</h5>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <app-training-details [trainingDetails]="initQualDetail?.trainingDetails"></app-training-details>
              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-12 mb-2">
                    <h5>Registration assessment</h5>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Year registration assessment passed</label>
                      <div
                        type="text"
                        name="reg"
                        class="form-control readonly"
                        [innerHTML]="UKdetails?.assessmentYear"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (isUserPharmacist && routeValue === 'EEA') {
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-8">
                    <div class="form-group">
                      <label>EEA country in which pharmacy qualification was obtained/EEA country in which qualification was first recognised</label>
                      <div
                        type="text"
                        name="reg"
                        class="form-control readonly"
                        [innerHTML]="EEADetails?.countryQualified || '-'"
                      ></div>
                    </div>
                  </div>
                </div>
                <!-- <div class="col-md-4" *ngIf="!isEEARegulatorSelected">
                <div class="form-group">
                  <label>Country of first recognition in the EEA</label>
                  <div
                    type="text"
                    name="reg"
                    class="form-control readonly"
                    [innerHTML]="EEADetails?.countryFirstRecognized || '-'"
                  ></div>
                </div>
              </div> -->
              <div class="row">
                @if (isEEARegulatorSelected) {
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>EEA directive route</label>
                      <div
                        type="text"
                        class="form-control readonly"
                        [innerHTML]="EEADetails?.eeaDirectiveRoute || '-'"
                      ></div>
                    </div>
                  </div>
                }
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Name of university or awarding body</label>
                    <div
                      type="text"
                      name="reg"
                      class="form-control readonly"
                      [innerHTML]="EEADetails?.nameOfUniversity || '-'"
                    ></div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <label>Course name</label>
                  <div
                    type="text"
                    class="form-control readonly"
                    [innerHTML]="EEADetails?.courseName || '-'"
                  ></div>
                </div>
                @if (isEEARegulatorSelected) {
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Year degree started</label>
                      <div
                        type="text"
                        class="form-control readonly"
                        [innerHTML]="EEADetails?.dateStarted || '-'"
                      ></div>
                    </div>
                  </div>
                }
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Year degree awarded</label>
                    <div
                      type="text"
                      class="form-control readonly"
                      [innerHTML]="EEADetails?.datePassed || '-'"
                    ></div>
                  </div>
                </div>
              </div>
              <br/>
              <br/>
            </div>
          }
          @if (routeValue === 'NorthernIreland') {
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Degree</label>
                    <div
                      type="text"
                      class="form-control readonly"
                      [innerHTML]="NIDetails?.courseName || '-' "
                    ></div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Year awarded</label>
                    <div
                      type="text"
                      name="reg"
                      class="form-control readonly"
                      [innerHTML]="NIDetails?.yearObtained || '-'"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          }
          @if (isUserPharmacist && (routeValue === 'OSPAP' || routeValue === 'Reciprocity')) {
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-12 mb-2">
                  <h5>Education</h5>
                </div>
              </div>
            </div>
            <!-- <ng-container *ngIf="routeValue === 'UK'">
            <div class="col-md-4">
              <div class="form-group">
                <label>Degree</label>
                <div
                  type="text"
                  name="reg"
                  class="form-control readonly"
                  [innerHTML]="registrationStatus || '-'"
                ></div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Year awarded</label>
                <div
                  type="text"
                  class="form-control readonly"
                  [innerHTML]="englishCertificateOption || '-'"
                ></div>
              </div>
            </div>
          </ng-container> -->
          @if (routeValue === 'OSPAP' || routeValue === 'Reciprocity') {
            <div class="col-md-12">
              <div class="row">
                @if (routeValue === 'Reciprocity') {
                  <div class="col-md-4" >
                    <div class="form-group">
                      <label>Country in which degree obtained</label>
                      <div
                        type="text"
                        name="reg"
                        class="form-control readonly"
                        [innerHTML]="OSPAPDetails?.ospapCountryQualified || '-'"
                      ></div>
                    </div>
                  </div>
                }
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Degree</label>
                    <div
                      type="text"
                      class="form-control readonly"
                      [innerHTML]="OSPAPDetails?.degreeName || '-' "
                    ></div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>University</label>
                    <div
                      type="text"
                      class="form-control readonly"
                      [innerHTML]="OSPAPDetails?.universityName || '-' "
                    ></div>
                  </div>
                </div>
                @if (routeValue !== 'Reciprocity') {
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Year awarded</label>
                      <div
                        type="text"
                        name="reg"
                        class="form-control readonly"
                        [innerHTML]="OSPAPDetails?.yearObtained || '-'"
                      ></div>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
          <ng-container>
            <div class="col-md-12">
              <div class="row">
                @if (routeValue === 'Reciprocity') {
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Year awarded</label>
                      <div
                        type="text"
                        name="reg"
                        class="form-control readonly"
                        [innerHTML]="OSPAPDetails?.yearObtained || '-'"
                      ></div>
                    </div>
                  </div>
                }
                @if (routeValue !== 'Reciprocity') {
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>OSPAP qualification</label>
                      <div
                        type="text"
                        class="form-control readonly"
                        [innerHTML]="OSPAPDetails?.ospapCourseName || '-'"
                      ></div>
                    </div>
                  </div>
                }
                @if (routeValue !== 'Reciprocity') {
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Date OSPAP qualification obtained</label>
                      <div
                        type="text"
                        class="form-control readonly"
                        [innerHTML]="(OSPAPDetails?.ospapDateQualified | utcDate) || '-'"
                      ></div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </ng-container>
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-12 mb-2">
                <h5>Pre-registration training/foundation training</h5>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <app-training-details [trainingDetails]="initQualDetail?.trainingDetails"></app-training-details>
          </div>
          @if (routeValue !== 'Reciprocity') {
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-12 mb-2">
                  <h5>Registration Assessment</h5>
                </div>
              </div>
            </div>
          }
          @if (routeValue !== 'Reciprocity') {
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Year registration assessment passed</label>
                    <div
                      type="text"
                      class="form-control readonly"
                      [innerHTML]="OSPAPDetails?.assessmentYear || '-'"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          }
        }
        @if (isUserPharmacist === false && routeValue === 'EEA') {
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Country of initial qualification</label>
                  <div
                    type="text"
                    name="reg"
                    class="form-control readonly"
                    [innerHTML]="PTDetails?.countryQualified"
                  ></div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Name of qualification</label>
                  <div
                    type="text"
                    class="form-control readonly"
                    [innerHTML]="(PTDetails?.courseName) || '-'"
                  ></div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Year qualification awarded</label>
                  <div
                    type="text"
                    class="form-control readonly"
                    [innerHTML]="(PTDetails?.datePassed) || '-'"
                  ></div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Awarding institution</label>
                  <div
                    type="text"
                    class="form-control readonly"
                    [innerHTML]="(PTDetails?.nameOfUniversity) || '-'"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        }
        @if (isUserPharmacist === false && routeValue !== 'EEA') {
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Qualification</label>
                  <div
                    type="text"
                    name="reg"
                    class="form-control readonly"
                    [innerHTML]="PTDetails?.degreeName1"
                  ></div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Date obtained</label>
                  <div
                    type="text"
                    class="form-control readonly"
                    [innerHTML]="(PTDetails?.qualifiedDate1 | utcDate) || '-'"
                  ></div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Qualification</label>
                  <div
                    type="text"
                    name="reg"
                    class="form-control readonly"
                    [innerHTML]="PTDetails?.degreeName2"
                  ></div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Date obtained</label>
                  <div
                    type="text"
                    class="form-control readonly"
                    [innerHTML]="(PTDetails?.qualifiedDate2 | utcDate) || '-'"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        }
        <div class="col-md-12">
          <app-application-ftp
            [application]="ftpQuestonsObj"
            [applicationType]="'ccps'"
          ></app-application-ftp>
        </div>
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-12 mb-2">
              <h5>Application Declaration</h5>
            </div>
          </div>
        </div>
        @if (isRegistered) {
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="declaration1">
                    The information I have provided for this application for a certificate
                    of current professional status and fitness to practise history is
                    complete, true and accurate.
                  </label>
                  <div
                    style="min-height: 40px"
                    class="form-control readonly"
                    [innerHTML]="
                      selectedApplication?.form?.appDeclaration?.isQ1Confirmed ? 'Yes' : (selectedApplication?.form?.appDeclaration?.isQ1Confirmed === false ? 'No' : '-')
                    "
                  ></div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="declaration2">
                    I am aware that I must notify the registrar of any changes to my name,
                    home address or other contact details within one month starting on the
                    day on which the change occurred.
                  </label>
                  <div
                    style="min-height: 40px"
                    class="form-control readonly"
                    [innerHTML]="
                      selectedApplication?.form?.appDeclaration?.isQ2Confirmed ? 'Yes' : 'No'
                    "
                  ></div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="declaration3">
                    I am aware that I must notify the registrar if there is any change in
                    the circumstances relating to the fitness to practise declaration that I
                    have made in this application within seven days, starting on the day on
                    which the event occurred.
                  </label>
                  <div
                    style="min-height: 40px"
                    class="form-control readonly"
                    [innerHTML]="
                      selectedApplication?.form?.appDeclaration?.isQ3Confirmed ? 'Yes' : (selectedApplication?.form?.appDeclaration?.isQ3Confirmed === false ? 'No' : '-')
                    "
                  ></div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="declaration4">
                    I understand that if I am found to have given false or misleading
                    information in connection with this application for a CCPS, this may be
                    treated as misconduct, which may result in my removal from the register.
                  </label>
                  <div
                    style="min-height: 40px"
                    class="form-control readonly"
                    [innerHTML]="selectedApplication?.form?.appDeclaration?.isQ4Confirmed ? 'Yes' : (selectedApplication?.form?.appDeclaration?.isQ4Confirmed === false ? 'No' : '-')"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        }
        @if (!isRegistered) {
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="declaration1">
                    The information I have provided for this application for a certificate of current
                    professional status and fitness to practise history is complete, true and accurate.
                  </label>
                  <div
                    style="min-height: 40px"
                    class="form-control readonly"
                    [innerHTML]="selectedApplication?.form?.appDeclaration?.isQ1Confirmed ? 'Yes' : (selectedApplication?.form?.appDeclaration?.isQ1Confirmed === false ? 'No' : '-')"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        }
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="declaration5">
                  I give my consent for the GPhC to use the information I have provided in this application
                  and any fitness to practise history (where applicable) to produce a CCPS and to send it to
                  my nominated regulatory authority. I am aware that this may mean my personal data will be
                  transferred outside the UK and the European Economic Area.
                </label>
                <div
                  style="min-height: 40px"
                  class="form-control readonly"
                  [innerHTML]="selectedApplication?.form?.appDeclaration?.isQ5Confirmed ? 'Yes' : (selectedApplication?.form?.appDeclaration?.isQ5Confirmed === false ? 'No' : '-')"
                ></div>
              </div>
            </div>
          </div>
        </div>
        @if (selectedApplication?.form?.attachments.length > 0) {
          @for (app of applications; track app) {
            <div class="col-md-12 supportingDocs">
              @if (app.form.id === selectedApplication?.form?.id) {
                <div>
                  <app-application-supporting-docs [isCCPS]="true"
                    [application]="app"
                  ></app-application-supporting-docs>
                </div>
              }
            </div>
          }
        }
      </div>
    </div>
  </cdk-accordion-item>
}
</cdk-accordion>
</div>

